<template>
  <main class='payment-callback mt-40'>
    <!-- <processSteps fullWidth></processSteps> -->
    <component
      :is="paymentTemplate"
      :qrcodeFor='qrcodeFor'
      :qrcodeImg='qrcodeImg'
      :qrcodeUrl="qrcodeUrl"></component>
  </main>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import _ from 'lodash'
import processSteps from '@/components/processSteps'
import defaultTemplate from '@/views/PaymentCallback/components/defaultTemplate'
import qrcodeTemplate from '@/views/PaymentCallback/components/qrcodeTemplate'

export default {
  name: 'PaymentCallback',
  components: {
    processSteps,
    defaultTemplate,
    qrcodeTemplate
  },
  data () {
    return {
      // paymentTemplate: 'defaultTemplate'
      // paymentTemplate: 'qrcodeTemplate'
    }
  },
  computed: {
    ...mapGetters([
      'isSuper',
      'hotelId',
      'order/plans',
      'order/paymentResponse'
    ]),
    paymentTemplate: function () {
      const hasQRcode = !_.isEmpty(this['order/paymentResponse']) &&
      !_.isEmpty(this['order/paymentResponse'].payment_payload) &&
      !_.isEmpty(this['order/paymentResponse'].payment_payload.Data) &&
      !_.isEmpty(this['order/paymentResponse'].payment_payload.Data.qrcode_url)

      return !hasQRcode ? 'defaultTemplate' : 'qrcodeTemplate'
    },
    qrcodeFor: function () {
      return this['order/paymentResponse'].payment_type
    },
    qrcodeImg: function () {
      return this['order/paymentResponse'].payment_payload.Data
        ? this['order/paymentResponse'].payment_payload.Data.qrcode_url
        : ''
    },
    qrcodeUrl: function () {
      return this['order/paymentResponse'].payment_payload.Data
        ? this['order/paymentResponse'].payment_payload.Data.urlToken
        : ''
    }
  },
  methods: {
    ...mapMutations([
      'SET_STEP'
    ])
  },
  // created () {
  //   this['SET_STEP'](4)
  // },
  activated () {
    if (!this.isSuper && _.isEmpty(this['order/plans'])) {
      this.$router.replace({
        name: 'Hotel',
        params: {
          hotelId: this.hotelId
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
